import { ImageScaleViewOpts } from '@play-co/timestep-core/lib/ui/ImageScaleView';
import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import { assertNever } from 'src/replicant/utils';
import { getPowerBlockMap } from '../game/defs/powerBlocks';
import {
  Match2Powerup,
  Match2PowerupType,
} from 'src/replicant/match2/match2.ruleset';
import { getMatch2AssetPath } from '../game/util/assets';
import { matchTheme } from 'src/game/theme/match2/Match2Theme';

type PowerupPanelOpts = Omit<ImageScaleViewOpts, 'image' | 'width' | 'height'>;

export class PowerupPanel extends ImageScaleView {
  constructor(powerup: Match2Powerup, opts: PowerupPanelOpts = {}) {
    super({
      image: 'assets/ui/match2/common/cell.png',
      height: 120,
      width: 491,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 30, right: 30 },
        vertical: { top: 30, bottom: 30 },
      },
      ...opts,
    });

    let icon: View | null = null;
    const powerupType = powerup.type;

    switch (powerupType) {
      case 'rocket':
      case 'bomb':
      case 'cube':
        icon = this.createPowerupIcon(powerupType, powerup.quantity);
        break;

      default:
        assertNever(powerupType);
    }

    icon.updateOpts({
      x: icon.style.width / 2 + 10,
      y: this.style.height / 2,
      centerOnOrigin: true,
    });

    // icon
    this.addSubview(icon);

    this.addSubview(
      new LangBitmapFontTextView({
        font: 'Body',
        color: '#BF8147',
        x: 285,
        y: this.style.height / 2,
        centerOnOrigin: true,
        size: 30,
        height: 100,
        width: 350,
        localeText: () =>
          i18n(`match2.powerups.purchase.${powerupType}.message`),
        verticalAlign: 'center',
        align: 'left',
        wordWrap: true,
      }),
    );
  }

  private createPowerupIcon(type: Match2PowerupType, quantity: number) {
    const bg = new ImageScaleView({
      width: 91,
      height: 95,
      image: matchTheme().getUIAsset('booster_frame.png'),
    });

    new ImageScaleView({
      superview: bg,
      width: 75,
      height: 75,
      image: `${getMatch2AssetPath(getPowerBlockMap()[type])}`,
      centerOnOrigin: true,
      x: bg.style.width / 2,
      y: bg.style.height / 2,
    });

    new LangBitmapFontTextView({
      superview: bg,
      font: 'Title',
      color: '#FFFFFF',
      size: 30,
      width: 90,
      height: 36,
      align: 'right',
      verticalAlign: 'center',
      y: bg.style.height - 30,
      localeText: () => `×${quantity}`,
    });

    return bg;
  }
}
